export default __webpack_public_path__ + "static/media/dogeface.9ba95a91.png";